import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { PropertyDataProvider } from './core/data/property-data.provider';
import { ThemeService } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly theme = inject(ThemeService);
  protected readonly navOpen = signal(false);

  private readonly meta = toSignal(inject(PropertyDataProvider).meta());

  /**
   * What the footer says about the data comes from the data.
   *
   * It used to assert "Данните са синтетични (seed) … интеграция с реални
   * портали е предвидена като фаза 2" in hard-coded prose. That was true right
   * up until it wasn't, and nothing would have flagged the day it stopped
   * being true — the same drift that left the methodology page describing a
   * generated dataset while the app served measured prices.
   */
  protected readonly dataSource = computed(() => {
    const m = this.meta();
    if (!m) return null;
    if (m.sourceId === null) return 'Няма заредени данни.';
    if (m.sourceId === 'seed') {
      return 'Показаните данни са синтетични (генериран набор) и служат за демонстрация на изчисленията.';
    }
    const last = m.months[m.months.length - 1];
    return `Данните са от обяви на ${m.sourceId}` + (last ? ` (снимка ${last})` : '') +
      ', с макро показатели от Eurostat и лихви от ЕЦБ.';
  });
}
